import React, { useState } from "react";
import { Box, VStack, HStack, Text, Button, Textarea } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const CheckmarkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M6.67 10.67L4.83 8.83L4.125 9.54L6.67 12.085L12.67 6.085L11.96 5.375L6.67 10.67Z"
      fill="#389D1B"
    />
  </svg>
);

export const FeatureLab = ({ onSuccess }) => {
  const [selectedType, setSelectedType] = useState("");
  const [feedback, setFeedback] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Get user email from profile store
  const userEmail = useSelector((state) => state.profile.data.email);

  const feedbackTypes = [
    { id: "idea", label: "Idea" },
    { id: "bug", label: "Bug" },
    { id: "ui-ux", label: "UI / UX Papercut" },
  ];

  const handleSubmit = async () => {
    if (!selectedType || !feedback.trim()) {
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("formType", "feature_feedback");
      formData.append("type", selectedType);
      formData.append("feedback", feedback.trim());
      formData.append("userEmail", userEmail || "");

      await fetch(process.env.REACT_APP_GOOGLE_APPS_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      // Since we're using no-cors mode, we can't read the response
      // but Google Apps Script will process the data successfully
      setSelectedType("");
      setFeedback("");
      setIsSubmitted(true);
      onSuccess?.();
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box bg="white" borderRadius="12px" p={3}>
      <VStack spacing={3} align="stretch">
        <Text
          fontSize="12px"
          fontWeight="400"
          lineHeight="1.5"
          letterSpacing="-1%"
          color="#000000"
          fontFamily="Geist, sans-serif"
        >
          💬 How can we improve Townhall? Please share feedback
        </Text>

        <HStack spacing={2} wrap="wrap">
          {feedbackTypes.map((type) => (
            <Box
              key={type.id}
              as="button"
              onClick={() => setSelectedType(type.id)}
              bg={selectedType === type.id ? "#4C47CC" : "white"}
              color={selectedType === type.id ? "white" : "#4C47CC"}
              borderWidth="1px"
              borderColor="#D0CCD5"
              borderRadius="4px"
              px={2}
              py="6px"
              fontSize="11px"
              fontWeight="400"
              lineHeight="1.45"
              letterSpacing="-0.01em"
              fontFamily="Geist, sans-serif"
              transition="all 0.2s"
              _hover={{
                bg: selectedType === type.id ? "#3D37B8" : "#F8F7FA",
              }}
            >
              {type.label}
            </Box>
          ))}
        </HStack>

        <Textarea
          bg="#F6F5F7"
          borderRadius="8px"
          p={3}
          placeholder="E.g Add ... to make it easier to ...."
          fontSize="11px"
          fontWeight="84"
          lineHeight="1.455"
          letterSpacing="-1%"
          color="#726682"
          fontFamily="Geist, sans-serif"
          border="none"
          _focus={{ boxShadow: "none" }}
          minH="80px"
          maxH="150px"
          resize="vertical"
          _placeholder={{ color: "#726682" }}
          value={feedback}
          maxLength={500}
          onChange={(e) => setFeedback(e.target.value)}
        />

        <HStack justify="space-between" align="center">
          <Text fontSize="11px" color="#8B8DA6" fontFamily="Geist, sans-serif">
            {feedback.length}/500 characters
          </Text>
          <Button
            bg="#4C47CC"
            color="white"
            fontSize="13px"
            fontWeight="146"
            lineHeight="1.231"
            fontFamily="Geist, sans-serif"
            borderRadius="8px"
            px="8px"
            py="8px"
            h="auto"
            minH="auto"
            w="fit-content"
            transition="all 0.2s"
            isLoading={isLoading}
            loadingText="Submitting..."
            isDisabled={
              !selectedType || !feedback.trim() || isLoading || isSubmitted
            }
            _hover={{
              bg: "#3A37B3",
              transform: !isLoading ? "translateY(-1px)" : "none",
            }}
            _active={{
              transform: "translateY(0px)",
            }}
            _disabled={{
              bg: "#B8B2C0",
              cursor: "not-allowed",
              transform: "none",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </HStack>

        {/* {isSubmitted && (
          <Box
            bg="rgba(56, 157, 27, 0.17)"
            borderRadius="8px"
            p={2}
            alignSelf="stretch"
          >
            <HStack spacing={2} justify="center">
              <CheckmarkIcon />
              <Text
                fontSize="13px"
                fontWeight="700"
                lineHeight="1.231"
                fontFamily="Geist, sans-serif"
                color="#389D1B"
              >
                Thank you, we received your message
              </Text>
            </HStack>
          </Box>
        )} */}
      </VStack>
    </Box>
  );
};
